// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import mainCards from './js/widgets/mainCards.js';
import autoEventFeed from './js/widgets/tier-3-section/autoEventFeed.js';
import * as socialNetworkWidget from './js/widgets/tier-3-section/socialNetworkWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import customSeo from './js/widgets/tier-4-section/customSeo.js';
import customSignup from './js/widgets/tier-4-section/customSignup.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();

    mainCards();

    $(globalThis).on('load', function () {
      socialNetworkWidget.facebookfeed(true);
      socialNetworkWidget.instafeed(false);
    });

    autoEventFeed();

    scrollerSponsors();

    customSeo();
    customSignup();
  }
});
